import React from 'react';
import { Download, Star, Users, Shield, Smartphone } from 'lucide-react';
import Screenshot1 from '../assets/screenshot1.png';

const Hero = () => {
  return (
    <section
      id='home'
      className='pt-40 pb-16 bg-gradient-to-br from-blue-50 via-white to-emerald-50 overflow-hidden'
    >
      <div className='container mx-auto px-4'>
        <div className='grid lg:grid-cols-2 gap-12 items-center'>
          {/* Left Content */}
          <div className='lg:pr-8'>
            {/* Badge */}
            <div className='mb-6'>
              <span className='inline-block bg-blue-100 text-blue-600 px-4 py-2 rounded-full text-sm font-medium mb-4 animate-bounce'>
                🎉 Versão 3.0 - Totalmente Renovado
              </span>
            </div>

            {/* Hero Title */}
            <h1 className='hero-title text-5xl lg:text-6xl font-bold mb-6 leading-tight'>
              Controle suas
              <span className='gradient-text block'>Finanças</span>
              de forma inteligente
            </h1>

            {/* Subtitle */}
            <p className='hero-subtitle text-xl text-gray-700 mb-8 leading-relaxed'>
              Tenha uma visão completa e imediata dos seus saldos, planeje seu
              futuro financeiro e alcance suas metas.{' '}
              <strong>FinZiin - Gratuito</strong>, com todas as funcionalidades
              essenciais desbloqueadas e sem limites de contas ou cartões.
            </p>

            {/* Stats - ajustados para visual mais limpo */}
            <div className='flex flex-wrap gap-6 mb-8'>
              {[
                {
                  icon: (
                    <Star className='w-5 h-5 text-yellow-500 fill-current' />
                  ),
                  bg: 'bg-yellow-100',
                  title: '4.8/5',
                  subtitle: 'Avaliação',
                },
                {
                  icon: <Users className='w-5 h-5 text-blue-500' />,
                  bg: 'bg-blue-100',
                  title: '500+',
                  subtitle: 'Usuários',
                },
                {
                  icon: <Shield className='w-5 h-5 text-emerald-500' />,
                  bg: 'bg-emerald-100',
                  title: '100%',
                  subtitle: 'Seguro',
                },
              ].map((item, i) => (
                <div
                  key={i}
                  className='flex items-center space-x-2 min-w-[120px]'
                >
                  <div className={`${item.bg} p-2 rounded-full`}>
                    {item.icon}
                  </div>
                  <div>
                    <div className='font-bold text-gray-800'>{item.title}</div>
                    <div className='text-sm text-gray-600'>{item.subtitle}</div>
                  </div>
                </div>
              ))}
            </div>

            {/* CTA Buttons - reforço visual e hierarquia */}
            <div className='flex flex-col sm:flex-row gap-4'>
              <a
                href='https://play.google.com/store/apps/details?id=br.android.finziin'
                target='_blank'
                rel='noopener noreferrer'
                className='btn-primary flex items-center justify-center space-x-3 text-lg px-8 py-4 hover:scale-105 transition-transform duration-300 shadow-lg'
              >
                <Download size={20} />
                <span>Baixar FinZiin - Gratuito</span>
              </a>

              <a
                href='#como-funciona'
                className='btn-secondary flex items-center justify-center space-x-3 text-lg px-8 py-4 hover:scale-105 transition-transform duration-300 shadow-md'
              >
                <Smartphone size={20} />
                <span>Ver Como Funciona</span>
              </a>
            </div>

            {/* Trust badges */}
            <div className='mt-8 pt-8 border-t border-gray-200 flex flex-col sm:flex-row items-start sm:items-center justify-start sm:justify-between gap-3'>
              <p className='text-sm text-gray-500 mb-2 sm:mb-0'>
                Disponível na Google Play
              </p>
              <div className='flex flex-wrap gap-2'>
                <div className='bg-green-100 text-green-700 px-3 py-1 rounded-full text-sm font-medium animate-pulse'>
                  ✓ FinZiin - Gratuito
                </div>
                <div className='bg-blue-100 text-blue-700 px-3 py-1 rounded-full text-sm font-medium animate-pulse'>
                  ✓ Contas e cartões ilimitados
                </div>
                <div className='bg-purple-100 text-purple-700 px-3 py-1 rounded-full text-sm font-medium animate-pulse'>
                  ✓ Backup seguro na nuvem
                </div>
              </div>
            </div>
          </div>

          {/* Right Content - App Screenshot */}
          <div className='relative lg:pl-8 flex justify-center lg:justify-end'>
            <div className='relative max-w-sm lg:mr-8'>
              {' '}
              {/* <-- adicionado lg:mr-8 para afastar da margem */}
              {/* Smartphone Frame */}
              <div className='relative bg-gray-900 rounded-[2.5rem] p-4 shadow-2xl'>
                <div className='bg-gray-800 rounded-[2rem] p-2'>
                  <div className='bg-gray-900 rounded-[1.5rem] overflow-hidden'>
                    {/* Print da tela do app */}
                    <img
                      src={Screenshot1}
                      alt='Print do App FinZiin'
                      className='w-full h-auto object-cover rounded-[1.5rem]'
                    />
                  </div>
                </div>
              </div>
              {/* Floating highlights opcionais */}
              <div className='absolute -top-4 -right-4 bg-emerald-500 text-white p-3 rounded-xl shadow-lg float-animation'>
                <div className='text-xs font-medium'>Receitas Pendentes</div>
                <div className='text-sm font-bold'>R$ 3.476,63</div>
              </div>
              <div
                className='absolute -bottom-4 -left-4 bg-blue-500 text-white p-3 rounded-xl shadow-lg float-animation'
                style={{ animationDelay: '1s' }}
              >
                <div className='text-xs font-medium'>Gastos Alimentação</div>
                <div className='text-sm font-bold'>R$ 646,91</div>
                <div className='text-xs font-medium'>restante</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
